import { useEffect, useState } from "react";
import axios from "axios";
import { MapPin, Clock, ArrowUpRight } from "lucide-react";
import { useT } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Open positions from the reserved area; "Candidati" preselects the position in the application form.
export const OpenJobs = ({ onApply }) => {
  const t = useT();
  const [jobs, setJobs] = useState(null);
  useEffect(() => {
    axios.get(`${API}/jobs`).then((r) => setJobs(Array.isArray(r.data?.jobs) ? r.data.jobs : [])).catch(() => setJobs([]));
  }, []);
  if (jobs === null) return null;
  return (
    <section className="px-5 py-20 sm:px-8 lg:py-24" data-testid="open-jobs">
      <div className="mx-auto max-w-[1500px]">
        <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">{t("jobs.h", "Posizioni aperte")}</h2>
        {jobs.length === 0 ? (
          <p className="mt-6 text-base text-[#4A453F]" data-testid="open-jobs-empty">{t("jobs.none", "Al momento non ci sono posizioni aperte: inviaci comunque una candidatura spontanea.")}</p>
        ) : (
          <ul className="mt-10 grid gap-4 md:grid-cols-2">
            {jobs.map((j) => (
              <li key={j.id} className="flex flex-col border border-[#121110]/15 p-6 sm:p-8" data-testid={`open-job-${j.id}`}>
                <h3 className="font-display text-2xl font-semibold tracking-tight">{j.title}</h3>
                <p className="mt-3 flex flex-wrap gap-x-5 gap-y-1 font-mono text-xs uppercase tracking-[0.15em] text-[#6E685E]">
                  {j.location && <span className="inline-flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" />{j.location}</span>}
                  {j.kind && <span className="inline-flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" />{j.kind}</span>}
                </p>
                {j.description && <p className="mt-4 flex-1 text-base leading-relaxed text-[#4A453F]">{j.description}</p>}
                <button type="button" onClick={() => onApply(j.title)} className="btn-amber mt-6 self-start" data-testid={`open-job-apply-${j.id}`}>
                  {t("jobs.apply", "Candidati")} <ArrowUpRight className="h-4 w-4" />
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
};
